import {modal} from './init-modal';

const initCompleteModal = () => {
    if (document.getElementById('CompleteModal')) {
        setTimeout(() => {           
            modal.openModal('CompleteModal');
        }, 5000);
    }
};

export default initCompleteModal;
